// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__3Mq79","input":"Checkbox_input__3X7kq","label":"Checkbox_label__TG9yw","labelContent":"Checkbox_labelContent__3_WnQ"};